import React from 'react';
import Link from '@atlaskit/link';
import { FormattedMessage } from '@atlassian/jira-intl';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export const SignInRedirect = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleLoginClick = () => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'no_permissions.login clicked', {
			source: globalThis.window?.location?.pathname ?? '',
			referrer: globalThis.document?.referrer ?? '',
			timestamp: new Date().toISOString(),
			userAgent: globalThis.navigator?.userAgent ?? '',
		});
	};

	return (
		<FormattedMessage
			{...messages.signIn}
			values={{
				link: (msg) => (
					<Link
						// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
						href={`/login.jsp?os_destination=${window.location.href}`}
						onClick={handleLoginClick}
					>
						{msg}
					</Link>
				),
			}}
		/>
	);
};
